module.exports = __webpack_public_path__ + "static/media/hodgens_soash_sweeney.6f0fc19c.gif";